import { z } from 'zod';
import { currencyCodeSchema, decimalStringSchema, isoDateSchema, positiveDecimalSchema } from './common';

export const investmentTypeSchema = z.enum([
  'stock',         // Hisse senedi
  'etf',           // ETF (Trade Republic, Scalable favorisi)
  'bond',          // Tahvil
  'fund',          // Yatırım fonu
  'crypto',        // BTC, ETH, vs.
  'reit',          // Gayrimenkul yatırım fonu
  'commodity',     // Altın, gümüş, vs.
  'other',
]);
export type InvestmentType = z.infer<typeof investmentTypeSchema>;

/**
 * ISO 6166 ISIN — 12 karakter (2 harf ülke + 9 alfanumerik + 1 check digit)
 * EU broker'ları (Trade Republic, Scalable, DEGIRO, eToro EU) hep ISIN kullanır.
 */
export const isinSchema = z
  .string()
  .length(12)
  .regex(/^[A-Z]{2}[A-Z0-9]{9}\d$/, 'ISIN: 2 harf ülke kodu + 9 alfanumerik + 1 rakam');
export type Isin = z.infer<typeof isinSchema>;

export const createInvestmentSchema = z.object({
  name: z.string().min(1).max(200),
  type: investmentTypeSchema,
  ticker: z.string().max(20).optional(),
  isin: isinSchema.optional(),
  broker: z.string().max(80).optional(),
  quantity: positiveDecimalSchema,
  avgCost: positiveDecimalSchema,
  currency: currencyCodeSchema.default('EUR'),
  currentPrice: decimalStringSchema.optional(),
  purchaseDate: isoDateSchema.optional(),
  note: z.string().max(2000).optional(),
  includeInNetWorth: z.boolean().optional().default(true),
});
export type CreateInvestmentInput = z.infer<typeof createInvestmentSchema>;

export const updateInvestmentSchema = createInvestmentSchema.partial();
export type UpdateInvestmentInput = z.infer<typeof updateInvestmentSchema>;

export const refreshPriceSchema = z.object({
  currentPrice: positiveDecimalSchema,
});
export type RefreshPriceInput = z.infer<typeof refreshPriceSchema>;
